// extracted by mini-css-extract-plugin
export default {"instruction":"_2ocpS6wlidsnp0S8b23QAP"};